import React, {useEffect, useRef, useState} from 'react';
import Card from '../Card';
import "./index.less"

export default ({
                    items,
                    contentStyle,
                    styleData,
                    buttonText,
                    cardClassName,
                    contentClassName,
                    dateStyle,
                    titleStyle,
                    descStyle,
                }) => {
    const carouselRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [hasDragged, setHasDragged] = useState(false);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3
    };

    useEffect(() => {
        const carousel = carouselRef.current;
        const cards = carousel.children;
        let totalCardWidth = 0;
        for (let i = 0; i < cards.length; i++) {
            totalCardWidth += cards[i].offsetWidth;
        }
        if (totalCardWidth > carousel.offsetWidth) {
            carousel.style.justifyContent = 'space-between';
        } else {
            carousel.style.justifyContent = 'center';
        }
    }, [items]);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - carouselRef.current.offsetLeft);
        setScrollLeft(carouselRef.current.scrollLeft);
        carouselRef.current.style.cursor = 'grabbing';
        carouselRef.current.style.userSelect = 'none';
    }

    const handleMouseLeave = () => {
        setIsDragging(false);
        carouselRef.current.style.cursor = 'grab';
        carouselRef.current.style.removeProperty('user-select');
    }

    const handleMouseUp = () => {
        setIsDragging(false);
        if (carouselRef.current) {
            carouselRef.current.style.cursor = 'grab';
            carouselRef.current.style.removeProperty('user-select');
        }
    }

    const handleMouseMove = (e) => {
        if (!isDragging) {
            setHasDragged(false);
            return;
        }
        setHasDragged(true);
        e.preventDefault();
        const x = e.pageX - carouselRef.current.offsetLeft;
        const walk = (x - startX) * 2;
        carouselRef.current.scrollLeft = scrollLeft - walk;
    }


    return <>
        <div
            className="carousel"
            ref={carouselRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            style={{cursor: 'grab'}}
        >
            {items.map((item, index) => (
                <Card key={index} {...item} hasDragged={hasDragged} contentStyle={contentStyle} styleData={styleData}
                      buttonText={buttonText} cardClassName={cardClassName} contentClassName={contentClassName} dateStyle={dateStyle} titleStyle={titleStyle} descStyle={dateStyle}/>
            ))}
        </div>
    </>
}
